import { DateTime } from "luxon";
import React, { Dispatch } from "react";

import { IgButton, IgPaper } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

import { FilterReducerAction, FilterReduceState } from "./index";

interface EventFilterProps {
  filters: FilterReduceState;
  dispatchFilters: Dispatch<FilterReducerAction>;
}

export const EventFilter = ({ filters, dispatchFilters }: EventFilterProps) => {
  const [tempStartTime, setTempStartTime] = React.useState<DateTime | null>(
    filters.startTime
  );
  const [tempEndTime, setTempEndTime] = React.useState<DateTime | null>(
    filters.endTime
  );

  return (
    <IgPaper sx={{ padding: "10px" }}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <Grid
          container
          item
          columnSpacing={2}
          justifyContent={"space-between"}
          flexWrap={"nowrap"}
        >
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              margin="none"
              fullWidth
              id="email"
              value={filters.value}
              onChange={(e) => {
                dispatchFilters({ type: "setValue", value: e.target.value });
              }}
              label="Filter by Experience Id or Name"
            />
          </Grid>
          <Grid
            container
            item
            columnSpacing={2}
            justifyContent={"end"}
            xs={6}
            flexWrap={"nowrap"}
          >
            <Grid item>
              <DateTimePicker
                disableFuture={true}
                label="Start Time"
                value={filters.startTime}
                onChange={(newValue) => {
                  setTempStartTime(newValue);
                }}
                onClose={() => {
                  dispatchFilters({ type: "setEndTime", value: tempEndTime });
                  dispatchFilters({
                    type: "setStartTime",
                    value: tempStartTime,
                  });
                }}
              />
            </Grid>
            <Grid item>
              <DateTimePicker
                disableFuture={true}
                label="End Time"
                value={filters.endTime}
                onChange={(newValue) => {
                  setTempEndTime(newValue);
                }}
                onClose={() => {
                  dispatchFilters({ type: "setEndTime", value: tempEndTime });
                  dispatchFilters({
                    type: "setStartTime",
                    value: tempStartTime,
                  });
                }}
              />
            </Grid>
          </Grid>
          <Grid item>
            <IgButton onClick={() => dispatchFilters({ type: "reset" })}>
              Clear
            </IgButton>
          </Grid>
        </Grid>
      </LocalizationProvider>
    </IgPaper>
  );
};
